module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-tabview p-component"
  }, [_c('ul', {
    ref: "nav",
    staticClass: "p-tabview-nav",
    attrs: {
      "role": "tablist"
    }
  }, [_vm._l((_vm.tabs), function(tab, i) {
    return _c('li', {
      key: _vm.getKey(tab, i),
      class: [{
        'p-highlight': (_vm.d_activeIndex === i),
        'p-disabled': _vm.isTabDisabled(tab)
      }],
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      staticClass: "p-tabview-nav-link",
      attrs: {
        "role": "tab",
        "tabindex": _vm.isTabDisabled(tab) ? null : '0',
        "aria-selected": _vm.d_activeIndex
      },
      on: {
        "click": function($event) {
          return _vm.onTabClick($event, i)
        },
        "keydown": function($event) {
          return _vm.onTabKeydown($event, i)
        }
      }
    }, [(tab.header) ? _c('span', {
      staticClass: "p-tabview-title"
    }, [_vm._v(_vm._s(tab.header))]) : _vm._e(), _vm._v(" "), (tab.$scopedSlots.header) ? _c('TabPanelHeaderSlot', {
      attrs: {
        "tab": tab
      }
    }) : _vm._e()], 1)])
  }), _vm._v(" "), _c('li', {
    ref: "inkbar",
    staticClass: "p-tabview-ink-bar"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "p-tabview-panels"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e478df3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/tabview/TabView.vue
// module id = 2427
// module chunks = 0